import MyproLoader from './MyproLoader';

const Loading = () => <MyproLoader fullHeight label="Memuat halaman" />;

export default Loading;
